import { z } from "zod"
import { type Article, articleSchema } from "@/models/article"
import { doGetRequest } from "@/lib/utils.ts"

export const authorSchema = z.object({
  id: z.number(),
  name: z.string(),
  surname: z.string(),
  biography: z.string().nullable().default(null),
  created_at: z.string(),
  updated_at: z.string(),
  articles_count: z.number().optional(),
})

export type Author = z.infer<typeof authorSchema>

export const getAuthors = async ({ signal }: { signal: AbortSignal }): Promise<Author[]> => {
  return doGetRequest("/api/authors", { signal }, (response:any) => {
    return response.data.map((author: any) => authorSchema.parse(author))
  })
}

export const getAuthorArticles = async ({
  id,
  signal
}: {
  id: number | undefined
  signal: AbortSignal
}): Promise<Article[]> => {
  if (!id) throw new Error("Author ID is required")

  return doGetRequest(`/api/authors/${id}/articles`, { signal }, (response:any) => {
    return response.data.map((article: any) => articleSchema.parse(article))
  })
}

export const authorName = (author: Author) => {
  return `${author.surname} ${author.name}`
}